import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import SliderBar from './dev/SliderBarSearch/SliderBar'

const VideoSliderBar = (props) => {
    const { messages, SetSliderRange, urlArgs: {
            subscriberCountFrom, subscriberCountTo,
            viewCountFrom, viewCountTo,
            engageRateFrom, engageRateTo,
        }
    } = props
    return (
        <VideoSliderBarWrap>
            <SubscriberCount>
                <SliderBar sliderTitle={messages.subscribers} sliderTitleDesc={[messages.dataDesc_subscriberCount]} onAfterChange={SetSliderRange(`subscriberCount`)} min={0} max={2000000} range={[subscriberCountFrom, subscriberCountTo]}></SliderBar>
            </SubscriberCount>
            <ViewCount>
                <SliderBar sliderTitle={messages.info_list_video_views} sliderTitleDesc={[messages.dataDesc_videoViews]} onAfterChange={SetSliderRange(`viewCount`)} min={0} max={2000000} range={[viewCountFrom, viewCountTo]}></SliderBar>
            </ViewCount>
            <EngageRate>
                <SliderBar sliderTitle={messages.info_list_video_engage} sliderTitleDesc={[messages.dataDesc_videoEngage]} onAfterChange={SetSliderRange(`engageRate`)} min={0} max={7} range={[engageRateFrom, engageRateTo]}></SliderBar>
            </EngageRate>
        </VideoSliderBarWrap>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(VideoSliderBar);
const VideoSliderBarWrap = styled.div`
    display: Grid;
    grid-template-columns: repeat(3,1fr);    
    grid-template-rows: 110px;
    grid-template-areas: 
    "SubscriberCount ViewCount EngageRate";
    grid-gap: 1px;
    width: 100%;
    height: 100%;
    background-color: #e6e6e6;
`
const Field = styled.div`
    padding: 20px;
    background-color: #fff;
    .ant-slider-rail {
        background-color: #e6e6e6;
    }
    .ant-slider-track {
        background-color: rgba(222,6,6,.5);
    }
    .ant-slider-handle {
        border: 2px solid #e6e6e6;
        &:focus {
            border: 2px solid #e94242;  
        }
        &.ant-tooltip-open {
            border: 2px solid #e94242;  
        }
    }
    .ant-slider:hover {
        .ant-slider-track {
            background-color: #e94242;        
        }
        .ant-slider-handle:not(.ant-tooltip-open) {
            border: 2px solid #e6e6e6;
        }
    }  
`
const SubscriberCount = Field.extend`
    grid-area: SubscriberCount;    
`
const ViewCount = Field.extend`
    grid-area: ViewCount;    
`
const EngageRate = Field.extend`
    grid-area: EngageRate;    
`



// WEBPACK FOOTER //
// ./src/InfoList/Search/VideoSliderBar.js